import { LogLevel } from '../app/shared/logging';

export const environment = {
  production: true,
  api_hostname: '{{HOSTNAME}}',
  api_url: '/backend/',
  atp_gateway_url: '{{ATP_GATEWAY_URL}}',
  version: '1.1.0 (969a1da)',
  base: '/mobile',
  logLevel: LogLevel.DEBUG,
  externalSupportUrl: 'https://usmcfitforce.com/',
  externalSupportHelpUrl: 'mailto:fitforce@aptima.com',
  preWktSurveyConfig: 'e211b946-d493-4b2b-a06b-d7c75ca355d4',
  registerUrl: 'https://fitforce-dev.aptima.com/account/',
  forgotUrl: 'https://fitforce-dev.aptima.com/account/forgot',
  plannerUrl: 'https://fitforce-dev.aptima.com/planner/',
  requestUrl: '{{REQUEST_URL}}',
  hideConsent: 'false',
  atpUrl: '/atp-graph/',
  minPasswordLength: '15',
};
